import type { ConnectorOauthExtraConfigProps } from "@app/lib/connector_providers_ui";
import { Input } from "@dust-tt/sparkle";
import { useLingui } from "@lingui/react/macro";
import { useEffect } from "react";

export function SlackOAuthExtraConfig({
  extraConfig,
  setExtraConfig,
  setIsExtraConfigValid,
}: ConnectorOauthExtraConfigProps) {
  const { t } = useLingui();
  useEffect(() => {
    setIsExtraConfigValid(
      !!extraConfig.client_id &&
        !!extraConfig.client_secret &&
        !!extraConfig.signing_secret
    );
  }, [extraConfig, setIsExtraConfigValid]);

  return (
    <div className="flex flex-col gap-4">
      <Input
        label={t`Slack app client ID`}
        message={t`The Client ID from your Slack app's, available on the Basic Information page.`}
        messageStatus="info"
        name="client_id"
        placeholder="1234567890.1234567890123"
        value={extraConfig.client_id ?? ""}
        onChange={(e) => {
          setExtraConfig((prev: Record<string, string>) => ({
            ...prev,
            client_id: e.target.value,
          }));
        }}
      />
      <Input
        label={t`Slack app client secret`}
        message={t`The Client Secret from your Slack app's, available on the Basic Information page.`}
        messageStatus="info"
        name="client_secret"
        placeholder="xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx"
        value={extraConfig.client_secret ?? ""}
        onChange={(e) => {
          setExtraConfig((prev: Record<string, string>) => ({
            ...prev,
            client_secret: e.target.value,
          }));
        }}
      />
      <Input
        label={t`Slack app signing secret`}
        message={t`The Signing Secret from your Slack app's, available on the Basic Information page.`}
        messageStatus="info"
        name="signing_secret"
        placeholder="xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx"
        value={extraConfig.signing_secret ?? ""}
        onChange={(e) => {
          setExtraConfig((prev: Record<string, string>) => ({
            ...prev,
            signing_secret: e.target.value,
          }));
        }}
      />
    </div>
  );
}
